import clsx from "clsx";
import css from "./CarsSearch.module.css";
import { IoIosSearch, IoIosClose } from "react-icons/io";

export default function CarsSearch({
  value,
  onChange,
  error,
  isHeader,
  isSmallInput = false,
  isSaleBalance = false,
  placeholderText = "Пошук по авто",
  inputStyle,
}) {
  const handleInputChange = event => {
    onChange(event.target.value);
  };

  const handleClearInput = () => {
    onChange("");
  };

  return (
    <div className={css.inputWrapper}>
      <input
        className={clsx(css.inputFilter, {
          [css.isHeader]: isHeader,
          [css.bigInput]: isSaleBalance,
          [css.smallInput]: isSmallInput,
        })}
        style={inputStyle}
        type="text"
        name="searchInput"
        id="searchInput"
        placeholder={placeholderText}
        value={value}
        onChange={handleInputChange}
      />
      <button className={css.button} type="button">
        <IoIosSearch className={css.icon} />
      </button>
      {value && (
        <button
          className={clsx(css.clearButton, {
            [css.saleBalance]: isSaleBalance,
          })}
          type="button"
          onClick={handleClearInput}
        >
          <IoIosClose className={css.clearIcon} />
        </button>
      )}
      {error && <div className={css.errorMsg}>{error}</div>}
    </div>
  );
}
